import { createGenerateClassName } from "@material-ui/core";
import { StylesProvider, ThemeProvider } from "@material-ui/core/styles";
import { DefaultTheme } from "@material-ui/styles";
import { ProductCatalog } from "./components/ProductCatalog/ProductCatalog";
import { WbCard } from "./components/WbCard/WbCard";
import { WbCardContent } from "./components/WbCard/WbCardContent";

interface Props {
  theme: DefaultTheme;
  descriptor?: any;
  outputport?: any;
}

function App({ theme, descriptor, outputport }: Props) {
  return (
    <StylesProvider
      injectFirst
      generateClassName={createGenerateClassName({ productionPrefix: "eqhub" })}
    >
      <ThemeProvider theme={theme}>
        <WbCard title="EQHub Industrial Equipment Catalog">
          <WbCardContent>
            <ProductCatalog descriptor={descriptor} outputport={outputport} />
          </WbCardContent>
        </WbCard>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
